import keyMirror from '../../services/key_mirror';

export const SET_ROUND_SESSION_ID = 'SET_ROUND_SESSION_ID';

export const READING_ACTION_TYPES = keyMirror([
  'UPDATE_GAME_DETAILS',
  'UPDATE_LOCAL_BOOK_STATE',
  'OPEN_BOOK',
  'CLOSE_BOOK',
  'OPEN_TOC',
  'CLOSE_TOC',
  'SET_READER_READY',
  'UPDATE_PAGINATION',
  'UPDATE_PAGINATION_STATUS',
  'LOCK_PAGINATION',
  'SET_BOOK',
  'SET_BOOK_STATE',
  'TRY_AGAIN',
  'SET_STATUS',
  'SHOW_UNANSWERED_QUESTIONS',
  'RETURN_TO_UNANSWERED_QUESTIONS',
  'SET_IS_DEEP_LINK_MASTERED',
], 'reading');

export const SETTINGS_ACTION_TYPES = keyMirror([
  'LOAD_USER_SETTINGS',
  'UPDATE_FONT_SIZE',
  'TOGGLE_SENTENCE_NUMBERING',
  'TOGGLE_READ_FOR_ME',
  'TOGGLE_REVEAL_WORDS',
], 'settings');

export const REVEAL_WORDS_ACTION_TYPES = keyMirror([
  'SET_REVEAL_WORDS',
  'SET_REVEAL_WORD',
  'CLEAR_REVEAL_WORD',
], 'revealWord');

export const READING_MODE_ACTION_TYPES = keyMirror([
  'MODE_CHANGED',
  'CHANGE_REQUESTED',
  'CHANGE_REQUEST_CANCELED',
  'ALL_MODES_COMPLETED',
  'RETURN_TO_CHALLENGE',
  'SET_SHOW_ALERTS',
], 'readingMode');

export const CONFIG_ACTION_TYPES = keyMirror([
  'SET_CONFIG',
], 'config');

export const ACTIVITY_ACTION_TYPES = keyMirror([
  'SET_ACTIVITIES',
  'SET_ACTIVITY_ORDER',
  'SET_ACTIVITY_POSITIONS',
  'SET_CHAPTER_ACTIVITIES',
  'SET_VISIBLE_ACTIVITIES',
  'SET_CURRENT_ACTIVITY',
  'CLEAR_ACTIVITY',
  'ANSWER',
  'ANSWER_CORRECT',
  'ANSWER_INCORRECT',
  'SET_TOTAL_QUESTIONS',
], 'activity');

export const EVIDENCE_TAGGING_ACTION_TYPES = keyMirror([
  'SELECT_INFERENCE',
  'OPEN_FIRST_PAGE',
  'SELECT_EVIDENCE',
  'UNTAG_EVIDENCE',
  'CLEAR_EVIDENCE_TAGGING_ANSWER',
  'CLEAR_EVIDENCE_TAGGING_EVIDENCE',
  'SET_ARROWS',
  'ANSWER',
], 'evidence_tagging');

export const INTERACT_ACTION_TYPES = keyMirror([
  'TOGGLE_POPUP',
  'SET_CONFIRMATION_DIALOG_VISIBILITY',
], 'interact');

export const POST_READING_ACTION_TYPES = keyMirror([
  'SET_ALL_QUESTIONS',
  'SET_REMAINING_QUESTIONS',
  'ANSWER',
  'ANSWER_CORRECT',
], 'post_reading');

export const GRAPHIC_ORGANIZER_ACTION_TYPES = keyMirror([
  'SET_QUESTIONS',
  'ACTIVATE',
  'OPEN',
  'CLOSE',
  'ANSWER',
], 'graphicOrganizer');

export const CAPTIONS_ACTION_TYPES = keyMirror(['SET_VOICE_CAPTIONS'], 'captions');
